import {
  SEARCH_TONTON_ADDRESS_SUCCESS,
  SEARCH_TONTON_ADDRESS_FAIL
} from '../action.types'
import InitialState from '../initial.state'

export default (state = InitialState.tontonSearchAddress, action) => {
  switch (action.type) {
    case SEARCH_TONTON_ADDRESS_SUCCESS:
      return [...action.payload]
    case SEARCH_TONTON_ADDRESS_FAIL:
      return state
    // case RESET_ADDRESS_SEARCH:
    //   return InitialState.searchAddress;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/address/searchTontonAddress.reducer.js